import {useEffect, useState} from "react";

export const useCachedImage = (key: string, url: string) => {
    const [src, setSrc] = useState<string | null>(null);

    useEffect(() => {
        const cached = localStorage.getItem(key);

        if (cached) {
            setSrc(cached);
            return;
        }

        fetch(url)
            .then(res => res.blob())
            .then(blob => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64 = reader.result as string;
                    localStorage.setItem(key, base64);
                    setSrc(base64);
                };
                reader.readAsDataURL(blob);
            });
    }, [key, url]);

    return src;
};
